import { gql } from '@apollo/client'

export const SABRE_GET_PACKAGING_SIZE_OPTIONS = gql`
  query GetPackagingSizeOptions($input: PackagingOptionQueryInput) {
    packagingSizes(input: $input) {
      count
      hasMore
      results
    }
  }
`
